import { ApiAddress } from '@/services/apis'
import { ID } from '@/services/common.model'
import request from '@/services/request'
import { Organization } from './organization.model'
import { Member } from '../member/member.model'

export function getOrganizationList(): Promise<Organization.Info[]> {
  return request.get(ApiAddress.ORGANIZATIONS)
}

export function getOrganizationById(id: ID): Promise<Organization.Info> {
  return request.get(ApiAddress.ORGANIZATION, { params: { id } })
}

export function createOrganization(data: Organization.Base) {
  return request.post(ApiAddress.ORGANIZATIONS, data)
}

export function updateOrganization(id: ID, data) {
  return request.put(ApiAddress.ORGANIZATION, data, { params: { id } })
}

export function deleteOrganization(id: ID) {
  return request.delete(ApiAddress.ORGANIZATION, { params: { id } })
}

export function leaveOrganization(id: ID) {
  return request.delete(ApiAddress.ORGANIZATION_LEAVE, { params: { id } })
}

export function getUserOrgAccount(id: ID): Promise<Member.Info> {
  return request.get(ApiAddress.USER_ORG_ACCOUNT, { params: { id } })
}